"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageUsersModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var components_1 = require("components");
var avatars_1 = require("components/Avatar/avatars");
var text_1 = require("utils/text");
require("./manageUsersModal.scss");
var listCssId = 'SSOManagementUsersModalCSS';
var dataKey = '__email';
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('selected', 'setSelected', []), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen !== 'CLOSED') {
                this.props.fetchUsers(this.props.sso, this.props.isOpen);
            }
            else {
                this.props.setSearchString('');
                this.props.setSelected([]);
            }
        }
        if (this.props.isOpen !== 'CLOSED') {
            if (this.props.listUsers !== prevProps.listUsers ||
                this.props.searchString !== prevProps.searchString) {
                this.props.setItems(this.props.listUsers
                    .filter(function (x) { return x.email.includes(_this.props.searchString); })
                    .sort(function (a, b) { return a.email.localeCompare(b.email); }));
            }
            if (this.props.items !== prevProps.items) {
                var contentWidth_1 = 0;
                var columns_1 = {};
                var text = (0, translation_1.getLocalization)("sso/management/users/modal/email");
                columns_1[dataKey] = (0, text_1.calculateStringLength)(text);
                this.props.listUsers.forEach(function (item) {
                    var emailLength = (0, text_1.calculateStringLength)(item.email);
                    var prevValue = columns_1[dataKey] || 0;
                    if (!prevProps || prevValue < emailLength) {
                        columns_1[dataKey] = emailLength;
                    }
                });
                // Override styles for dynamic classes
                var style = document.getElementById(listCssId);
                if (style && style.parentNode) {
                    style.parentNode.removeChild(style);
                }
                style = document.createElement('style');
                style.id = listCssId;
                document.head && document.head.appendChild(style);
                var sheet_1 = style.sheet;
                contentWidth_1 += 1 * 40;
                Object.keys(columns_1).forEach(function (className, i) {
                    var col = columns_1[className];
                    if (col === undefined)
                        return;
                    var colwidth = Math.max(8, 4 + col + 26); // convert to rem
                    contentWidth_1 += colwidth;
                    sheet_1.insertRule(".".concat(className) +
                        ' {max-width: ' +
                        colwidth +
                        'px;\n min-width: ' +
                        colwidth +
                        'px;}', i);
                });
                this.props.setContentWidth(contentWidth_1);
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isOpen !== 'CLOSED' ||
            this.props.isOpen !== nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var createRowData = function (style, items, selected, setSelected) { return ({
    style: style,
    items: items,
    selected: selected,
    setSelected: setSelected
}); };
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-users', className: 'no-users' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("sso/management/users/emptyList/title")))); };
var ListHeader = function (props) {
    var allSelected = props.items.length > 0 && props.items.length === props.selected.length;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { circle: true, className: allSelected ? 'selected' : undefined, icon: 'fa-check', onClick: function () {
                    if (allSelected) {
                        props.setSelected([]);
                    }
                    else {
                        props.setSelected(__spreadArray([], props.items, true));
                    }
                } })),
        React.createElement("div", { className: 'row__column dynamic __email' },
            React.createElement("div", null, (0, translation_1.getLocalization)("sso/management/users/modal/email"))),
        React.createElement("div", { className: "row__column narrow" })));
};
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, selected = data.selected, setSelected = data.setSelected;
    var row = items[index];
    var isSelected = selected.find(function (x) { return x.id === row.id; });
    return (React.createElement("div", { className: 'row', style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { circle: true, className: isSelected && 'selected', icon: 'fa-check', onClick: function () {
                    if (isSelected) {
                        setSelected(selected.filter(function (x) { return x.id !== row.id; }));
                    }
                    else {
                        setSelected(__spreadArray(__spreadArray([], selected, true), [row], false));
                    }
                } })),
        React.createElement("div", { className: 'row__column dynamic mobile __email' }, row.email),
        React.createElement("div", { className: "row__column narrow" })));
}, function (prev, next) {
    return !(0, List_1.shallowDiffers)(prev, next) && prev.data.selected === next.data.selected;
});
exports.ManageUsersModal = enhance(function (props) {
    var itemData = createRowData({}, props.items, props.selected, props.setSelected);
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen !== 'CLOSED', className: 'sso-management-convert-users' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.setIsOpen('CLOSED'); } }, (0, translation_1.getLocalization)('sso/management/convert/users/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.convertUsersStatus },
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/convert/convertings')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/convert/converted')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/convert/failed'))),
            React.createElement("div", null,
                React.createElement(sok_ui_1.TextInput, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-search' }), iconRight: props.searchString && (React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () { return props.setSearchString(''); } })), value: props.searchString, onChange: function (e) {
                        props.setSearchString(e.target.value);
                    } })),
            React.createElement("div", { className: 'sso-management-view-users-list-container' },
                React.createElement("div", { className: 'sok-list-content sso-management-view-users-list' },
                    props.listUsersStatus === 'FAILURE' && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                                return props.isOpen !== 'CLOSED' &&
                                    props.fetchUsers(props.sso, props.isOpen);
                            } }))),
                    (props.listUsersStatus === 'FETCHING' ||
                        props.listUsersStatus === 'STANDBY') && (React.createElement("div", { key: 'loading', className: 'loading' },
                        React.createElement(sok_ui_1.LoadingSpinner, null))),
                    props.listUsersStatus === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                        var width = _a.width, height = _a.height;
                        return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(ListHeader, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                    }))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.convertUsersStatus === 'FETCHING' ||
                    props.selected.length === 0 ||
                    props.isOpen !== 'NOT_FEDERATED', text: (0, translation_1.getLocalization)('buttons/convert'), onClick: function () {
                    return props.selected && props.convertUsers(props.sso, props.selected);
                } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () { return props.setIsOpen('CLOSED'); } }))));
});
